import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Security.css';

const splitHeadingLetters = (text) =>
  text.split('').map((character, index) => (
    <span
      key={`${text}-${index}`}
      className={`security-heading-letter${character === ' ' ? ' is-space' : ''}`}
      style={{ '--letter-index': index }}
      aria-hidden="true"
    >
      {character === ' ' ? '\u00A0' : character}
    </span>
  ));

const SecurityPage = () => {
  const [isHeadingVisible, setIsHeadingVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setIsHeadingVisible(true);
    }, 80);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <div className="security-page-wrapper">
      <div className="security-page-container security-page">
        <div className="security-back-link">
          <Link to="/">&larr; Back to Home</Link>
        </div>

        <div className="security-page-hero">
          <h1
            className={`security-heading ${isHeadingVisible ? 'is-visible' : ''}`}
            aria-label="Security"
          >
            {splitHeadingLetters('Security')}
          </h1>
          <p>
            Security is foundational to BlackRoth's platform architecture. We
            implement comprehensive safeguards, monitoring systems, and
            compliance practices to ensure the protection, integrity, and
            availability of customer data.
          </p>
        </div>

        <section className="security-page-section">
          <h2 className="security-section-heading">Infrastructure Protection</h2>
          <p>
            Our infrastructure operates within hardened environments leveraging
            network segmentation, firewalls, intrusion detection systems, and
            continuous vulnerability assessments to mitigate evolving threats.
          </p>
        </section>

        <section className="security-page-section">
          <h2 className="security-section-heading">Data Encryption</h2>
          <p>
            We employ strong encryption protocols for data in transit and at
            rest. Industry-standard cryptographic practices ensure sensitive
            information remains protected from unauthorized exposure.
          </p>
        </section>

        <section className="security-page-section">
          <h2 className="security-section-heading">Access Controls</h2>
          <p>
            Role-based access management, multi-factor authentication, and audit
            logging mechanisms restrict data access strictly to authorized
            personnel and monitored operational processes.
          </p>
        </section>

        <section className="security-page-section">
          <h2 className="security-section-heading">Compliance &amp; Monitoring</h2>
          <p>
            BlackRoth aligns with global security and compliance standards. We
            continuously monitor systems, conduct security reviews, and enhance
            controls to address emerging cybersecurity risks.
          </p>
        </section>
      </div>
    </div>
  );
};

export default SecurityPage;
